// Google Fonts support. Installers pick from this curated list (every family
// here has 400 and 700 weights, which is what the widget requests).
//
// Fonts must be loaded into the host DOCUMENT, not the widget's shadow root:
// @font-face declared inside a shadow root is ignored by browsers, but faces
// loaded by the page are usable inside it.

export const GOOGLE_FONTS: { family: string; category: "sans" | "serif" | "display" }[] = [
  { family: "Inter", category: "sans" },
  { family: "Roboto", category: "sans" },
  { family: "Open Sans", category: "sans" },
  { family: "Lato", category: "sans" },
  { family: "Montserrat", category: "sans" },
  { family: "Poppins", category: "sans" },
  { family: "Nunito", category: "sans" },
  { family: "Nunito Sans", category: "sans" },
  { family: "Raleway", category: "sans" },
  { family: "Source Sans 3", category: "sans" },
  { family: "Work Sans", category: "sans" },
  { family: "DM Sans", category: "sans" },
  { family: "Manrope", category: "sans" },
  { family: "Rubik", category: "sans" },
  { family: "Mulish", category: "sans" },
  { family: "Karla", category: "sans" },
  { family: "Barlow", category: "sans" },
  { family: "IBM Plex Sans", category: "sans" },
  { family: "Fira Sans", category: "sans" },
  { family: "PT Sans", category: "sans" },
  { family: "Noto Sans", category: "sans" },
  { family: "Outfit", category: "sans" },
  { family: "Plus Jakarta Sans", category: "sans" },
  { family: "Figtree", category: "sans" },
  { family: "Lexend", category: "sans" },
  { family: "Urbanist", category: "sans" },
  { family: "Sora", category: "sans" },
  { family: "Space Grotesk", category: "sans" },
  { family: "Josefin Sans", category: "sans" },
  { family: "Quicksand", category: "sans" },
  { family: "Cabin", category: "sans" },
  { family: "Hind", category: "sans" },
  { family: "Ubuntu", category: "sans" },
  { family: "Titillium Web", category: "sans" },
  { family: "Libre Franklin", category: "sans" },
  { family: "Archivo", category: "sans" },
  { family: "Encode Sans Semi Expanded", category: "sans" },
  { family: "Merriweather", category: "serif" },
  { family: "Playfair Display", category: "serif" },
  { family: "Lora", category: "serif" },
  { family: "Libre Baskerville", category: "serif" },
  { family: "Roboto Slab", category: "serif" },
  { family: "Source Serif 4", category: "serif" },
  { family: "Bitter", category: "serif" },
  { family: "Oswald", category: "display" },
];

/** CSS font-family value with sensible fallbacks for the family's category. */
export function fontStack(family: string): string {
  const cat = GOOGLE_FONTS.find((f) => f.family === family)?.category ?? "sans";
  const fallback = cat === "serif" ? "Georgia, 'Times New Roman', serif" : "system-ui, -apple-system, 'Segoe UI', Helvetica, Arial, sans-serif";
  return `'${family.replace(/'/g, "")}', ${fallback}`;
}

/** Google Fonts CSS URL for one family (regular + bold). */
export function googleFontUrl(family: string): string {
  return `https://fonts.googleapis.com/css2?family=${encodeURIComponent(family).replace(/%20/g, "+")}:wght@400;700&display=swap`;
}

/** Add the family's stylesheet to the document once (idempotent). */
export function ensureGoogleFont(family: string, doc: Document = document): void {
  const id = `xq-font-${family.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`;
  if (doc.getElementById(id)) return;
  const link = doc.createElement("link");
  link.id = id;
  link.rel = "stylesheet";
  link.href = googleFontUrl(family);
  doc.head.appendChild(link);
}
